function stateReducer(state, action) {
    var _a, _b;
    switch (action.type) {
        case 'RegisterChild': {
            if ((_a = state.childrens) === null || _a === void 0 ? void 0 : _a.includes(action.children))
                return state;
            const currentChildren = (state === null || state === void 0 ? void 0 : state.childrens) || [];
            return Object.assign(Object.assign({}, state), { childrens: [...currentChildren, action.children] });
        }
        case 'UnregisterChild': {
            return Object.assign(Object.assign({}, state), { childrens: (_b = state.childrens) === null || _b === void 0 ? void 0 : _b.filter((child) => child !== action.children) });
        }
    }
}
export default stateReducer;
